import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);

//实例store对象
const store = new Vuex.Store({
    state: {
        user: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {},
        auth: localStorage.getItem('auth') ? localStorage.getItem('auth') : {},
        config: localStorage.getItem('config') ? JSON.parse(localStorage.getItem('config')) : {},
        i18n: localStorage.getItem('i18n') ? localStorage.getItem('i18n') : 'zh_TW',
        lang: {},
    },
    mutations: {
        /*......*/
    }
})

//导出store对象
export default store


// WEBPACK FOOTER //
// ./src/store/index.js